import { render, staticRenderFns } from "./ListScaffold.vue?vue&type=template&id=791fc909&scoped=true"
import script from "./ListScaffold.vue?vue&type=script&lang=ts"
export * from "./ListScaffold.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791fc909",
  null
  
)

export default component.exports